import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { Client, WsState } from '../../common/types/interfaces'

const initialState: WsState = {
  connected: false,
  connectedList: [],
}

export const wsSlice = createSlice({
  name: 'ws',
  initialState,
  reducers: {
    setConnected: (state, action: PayloadAction<boolean>) => {
      state.connected = action.payload
    },
    setConnectedList: (state, action: PayloadAction<Client[] | []>) => {
      state.connectedList = action.payload
    },
  },
})

export const { setConnected } = wsSlice.actions
export const { setConnectedList } = wsSlice.actions
export const selectConnected = (state: RootState) => state.ws.connected
export const selectConnectedList = (state: RootState) => state.ws.connectedList

export default wsSlice.reducer
